module.exports = __webpack_public_path__ + "img/section5_pic1.47418b9b.png";